import React, { Fragment, useState } from "react";
import { translate } from "../../Services/translation";

const ProductSearchViewer = props => {

    const sortData = props.sortKey ? `&sort_by=${props.sortKey}&sort_direction=${props.sortDirection}` : '';
    var results = props.Results ? JSON.parse(props.Results) : [];
    var pagination = props.Pagination ? JSON.parse(props.Pagination) : [];
    const queryString = window.location.search.substr(1);
    let query = "";
    let queryUrl = "";

    queryString.split('&')
        .filter((param) => {
            const [id, value] = param.split('=');
            if (id === "q") {
                query = value;
            }
        });

    const changePaginationNumber = (index) => {
        if (queryString.indexOf("&page=") > -1) {
            let queryIndex = 0;
            queryString.split('&')
                .forEach((param) => {
                    let [id, value] = param.split('=');
                    queryUrl = `${queryUrl}${queryIndex === 0 ? "?" : "&"}${id === "page" ? param.replace(`page=${value}`, `page=${index}`) : param}`;
                    queryIndex++;
                });
            window.location = window.location.href.split("?")[0] + queryUrl;
        } else {
            window.location = window.location + "&page=" + index;
        }
    }

    const sortResults = (sortQuery) => {
        let queryIndex = 0;
        queryString.split('&')
            .forEach((param) => {
                let [id, value] = param.split('=');
                if (id.indexOf("sort_") < 0) {
                    queryUrl = `${queryUrl}${queryIndex === 0 ? "?" : "&"}${param}`;
                }
                queryIndex++;
            });
        window.location = `${window.location.href.split("?")[0]}${queryUrl}${sortQuery}`;
    }

    const paginationView = (pageCount, currentPageNumber, setCurrentPage) => {
        const pageNumbers = (currentPage, maxValue) => [...Array(5)]
            .map((_, index) => (currentPage - 2 + index))
            .filter((val) => (val <= maxValue && val >= 1));

        return (pageCount > 1 && <ul className="pagination">
            {currentPageNumber > 3 && <li className="pagination__item " key='pagination__item_first'>
                <div className={`pagination__link pagination__link`} onClick={() => setCurrentPage(1)}>{translate('pagination.first.label')}</div>
            </li>}
            <li className="pagination__item " key={'pagination__item' + 'Forrige'}>
                <div className={`pagination__link ${Number(currentPageNumber) === Number(1) ? 'pagination__link--disabled' : ''}`} onClick={() => setCurrentPage(currentPageNumber - 1)} >{translate('pagination.previous.label')}</div>
            </li>
            {[...pageNumbers(currentPageNumber, pageCount)].map((i) =>
                <li className="pagination__item" key={'pagination__item' + i}>
                    <div onClick={() => setCurrentPage(i)} className={`pagination__link pagination__link${i === currentPageNumber ? '--current' : ''}`}>{i}</div>
                </li>
            )}
            <li className="pagination__item " key={'pagination__item' + 'Neste'}>
                <div onClick={() => setCurrentPage(currentPageNumber + 1)} className={`pagination__link ${Number(currentPageNumber) === Number(pageCount) ? 'pagination__link--disabled' : ''}`}>{translate('pagination.next.label')}</div>
            </li>
            {pageCount - currentPageNumber > 3 && <li className="pagination__item " key='pagination__item_last'>
                <div className={`pagination__link pagination__link`} onClick={() => setCurrentPage(pageCount)}>{translate('pagination.last.label')}</div>
            </li>}
        </ul>)
    }

    const sortView = () => {
        return (<select onChange={(e) => sortResults(e.target.value)} value={sortData}>
            <option value='' disabled selected>
                {translate('coptikk.search.sortdefaultoption')}
            </option>
            <option value={`&sort_by=name&sort_direction=Ascending`}>
                {translate('coptikk.sort.bynameasc')}
            </option>
            <option value={`&sort_by=name&sort_direction=Descending`}>
                {translate('coptikk.sort.bynamedesc')}
            </option>
        </select>)
    }

    return (
        <Fragment>
            <div className="search-result-page__product-sorting">
                <div className="column small-12">
                    {sortView()}
                </div>
            </div>
            <div className="row">
                <ul className="column small-12 product-search-result product-list">
                    {results.map(item => {
                        return <li className="product-list__item columns small-6 medium-4 large-4">
                            <div className="product__wrapper">
                                <div className="product__figure">
                                    <a href={item.url} className="product__image-link">
                                        <img src={item.imageUrl} className="product__image"></img>
                                    </a>
                                </div>
                                <div className="product__info">
                                    <div>{item.name}</div>
                                    <p className="product__category-type">{item.categoryName}</p>
                                    <div className="product__price">{item.priceWithVat},-</div>
                                    <a href={item.url} className="product__button">{translate('coptikk.productsearch.showallresults')}</a>
                                </div>
                            </div>
                        </li>
                    })}
                </ul>
            </div>
            <div className="row">
                <div className="column small-12">
                    {paginationView(pagination.pageCount, pagination.currentPageIndex, changePaginationNumber)}
                </div>
            </div>
        </Fragment>)
}

export default ProductSearchViewer;